/* @flow */

export default {
  root: {
    maxWidth: 184,
    marginTop: 16,
    padding: [16, 12, 0],
  },
};
